import { render, staticRenderFns } from "./h3c-server-table-get.vue?vue&type=template&id=1715e930&scoped=true&"
import script from "./h3c-server-table-get.vue?vue&type=script&lang=js&"
export * from "./h3c-server-table-get.vue?vue&type=script&lang=js&"
import style0 from "./h3c-server-table-get.vue?vue&type=style&index=0&id=1715e930&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1715e930",
  null
  
)

export default component.exports